import { PART_STATUSES, PROCESSING_CATEGORIES } from '@frontend/api';
import type { ProcessingStatuses } from '@frontend/api';

/**
 * Function for determining whether a component's thumbnail is ready.
 *
 * @param processingStatuses
 *   An object with the processing statuses to be checked for whether the
 *   thumbnail is ready.
 * @returns
 *   Returns true if the thumbnail is ready, false if the thumbnail is not
 *   ready, and null if the status information required to determine whether the
 *   thumbnail is ready is not available.
 */
export const getIsThumbnailReadyFromProcessingStatuses = (
  processingStatuses?: ProcessingStatuses | null,
): boolean | null => {
  if (processingStatuses) {
    const processingStatus =
      processingStatuses[PROCESSING_CATEGORIES.PROCESSING]?.status;
    const processingIsComplete =
      processingStatus === PART_STATUSES.FINISHED || processingStatus === null;

    const thumbnailCreationStatus =
      processingStatuses[PROCESSING_CATEGORIES.THUMBNAIL_CREATION]?.status;
    const thumbnailCreationIsComplete =
      thumbnailCreationStatus === PART_STATUSES.FINISHED ||
      thumbnailCreationStatus === null;

    const thumbnailIsReady =
      processingIsComplete && thumbnailCreationIsComplete;

    return thumbnailIsReady;
  }

  return null;
};
